import { ReactComponent as Invite } from "assets/icons/invite.svg";

import {
  DocumentDuplicateIcon,
  EllipsisVerticalIcon,
} from "@heroicons/react/24/outline";
import { ComingSoon, Loading, Modal } from "components/commons";
import { Breadcum } from "components/commons/Breadcum";
import { tabs } from "helpers/constants";
import slugs from "navigation/slugs";
import { useEffect, useRef, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useNavigate } from "react-router-dom";
import {
  currencyFormatter,
  formatAmount,
  formatNumber,
} from "utils/number/number";
import { useController } from "./Controller";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

function Profile() {
  const {
    data,
    currentTab,
    setCurrentTab,
    isLoading,
    poolSupply,
    handleBuyShare,
    handleLogout,
    accountShares,
    buyPrice,
    handleSellShare,
    sellPrice,
  } = useController();

  const navigate = useNavigate();

  const [isOpenInvite, setIsOpenInvite] = useState<boolean>(false);
  const [isOpenTrade, setIsOpenTrade] = useState<boolean>(false);
  const [isCopied, setIsCopied] = useState(false);

  const toggleModalInvite = () => {
    setIsOpenInvite(!isOpenInvite);
  };

  const toggleModalTrade = () => {
    setIsOpenTrade(!isOpenTrade);
  };

  const tabRender = () => {
    switch (currentTab) {
      case "Stream":
        return (
          <ComingSoon
            type="speaker"
            des="Exclusive videos for your Shareholders only."
          />
        );

      case "Perks":
        return (
          <ComingSoon
            type="gift"
            des="Your Exclusive Perks to attract more Shareholders."
          />
        );

      default:
        break;
    }
  };

  const tiktokUserInfo = data?.tiktok_user_info;
  const avatar = tiktokUserInfo?.metadata?.avatar_300x300;
  const avatarSmall = tiktokUserInfo?.metadata?.avatar_168x168;

  const currentPrice = currencyFormatter(data?.current_price, 4);
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const popoverRef = useRef<any>(null);

  // Close the popover when clicking outside of it
  useEffect(() => {
    const handleOutsideClick = (event: any) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setIsOpenMenu(false);
      }
    };

    if (isOpenMenu) {
      document.addEventListener("touchend", handleOutsideClick);
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("touchend", handleOutsideClick);
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("touchend", handleOutsideClick);
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpenMenu]);

  return (
    <>
      <Breadcum
        title={tiktokUserInfo?.nickname}
        iconLeft={
          <div
            className="w-6 h-6 rounded-full bg-[#FF9F00] border-[3px] border-[#FFD60A] text-xs font-bold flex justify-center items-center"
            onClick={() => navigate(slugs.point)}
          >
            P
          </div>
        }
        iconRight={
          <div className="relative inline-block" ref={popoverRef}>
            <button
              onClick={() => {
                setIsOpenMenu(true);
              }}
            >
              <EllipsisVerticalIcon className="w-8 h-8 p-1" />
            </button>
            {isOpenMenu && (
              <div className="flex flex-col gap-1 bg-[#020617] origin-top-right absolute right-0 w-32 rounded-xl transition-opacity duration-300 border border-[#19212E] divide-y divide-[#19212E] text-[#CBD5E1]">
                <button
                  className="p-3 text-left"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(slugs.profileBalance);
                  }}
                >
                  My balance
                </button>
                <button
                  className="p-3 text-left"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleModalInvite();
                    setIsOpenMenu(false);
                  }}
                >
                  Invite Frens
                </button>
                <button
                  className="p-3 text-left"
                  onClick={() => {
                    handleLogout();
                  }}
                >
                  Logout
                </button>
                <button
                  className="p-3 text-left"
                  onClick={() => {
                    window.location?.reload();
                  }}
                >
                  Refresh
                </button>
              </div>
            )}
          </div>
        }
      />

      <Modal isOpen={isOpenInvite} toggleModal={toggleModalInvite}>
        <div className=" flex flex-col justify-center items-center gap-4 py-6 px-12 pb-16">
          <Invite className="w-24" />
          <div className="space-y-2 flex flex-col">
            <span className="text-xl text-center">Invite a Fren</span>

            <span className="text-sm text-center text-slate-300">
              Use one of the following codes to invite your friend.
            </span>
          </div>

          <div className="text-sm white font-normal bg-gray-800 py-2 px-4 rounded-xl flex">
            {data?.referral_code}

            <CopyToClipboard
              text={data?.referral_code}
              onCopy={() => {
                setIsCopied(true);
              }}
            >
              <button className={`text-xs flex gap-1`}>
                <DocumentDuplicateIcon
                  className={`w-4 h-4 inline ml-2  ${
                    isCopied
                      ? "stroke-1 stroke-slate-500"
                      : "stroke-2 stroke-white"
                  }`}
                />
              </button>
            </CopyToClipboard>
          </div>
        </div>
      </Modal>

      <Modal isOpen={isOpenTrade} toggleModal={toggleModalTrade}>
        <div className=" border-gray-800 px-4">
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <img
                className="border w-16 h-16 rounded-full border-slate-700"
                src={data?.tiktok_user_info?.metadata?.avatar_168x168}
              />
              <div className="space-y-1 flex-1">
                <div>{data?.tiktok_user_info?.unique_id}</div>{" "}
                <div className="text-xs text-slate-500 font-normal">
                  You own {accountShares || 0} shares
                </div>
              </div>
              <div className="space-y-1">
                <div className="text-right">
                  {formatAmount(buyPrice, 18, 4)} ETH
                </div>{" "}
                <div className="text-right text-xs text-slate-500 font-normal">
                  Share price{" "}
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </div>

        <div className="flex flex-col px-4 gap-3 pb-8">
          <button
            className="rounded-xl btn bg-secondary uppercase w-full"
            onClick={async (e) => {
              e.preventDefault();
              handleBuyShare();
            }}
          >
            Buy a Share
          </button>

          <button
            className="rounded-xl btn bg-[#279EFF] uppercase w-full"
            onClick={(e) => {
              e.preventDefault();
              handleSellShare();
            }}
          >
            Sell a Share
          </button>
          <div className="text-xs text-slate-300 font-normal text-center pt-4">
            Sell price: {formatAmount(sellPrice ?? 0, 18, 4)} ETH
          </div>
        </div>
      </Modal>

      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="p-4">
            <div className="px-2 gap-4 flex flex-col">
              <div className="flex flex-col justify-center items-center gap-2">
                <img
                  className="border w-20 h-20 rounded-full border-slate-700"
                  alt="avatar"
                  src={avatar}
                />
                <div className="text-xs text-center font-normal">
                  @{tiktokUserInfo?.unique_id}
                </div>
                <div className="mx-auto space-y-2">
                  <div className="flex items-center  gap-1 rounded-xl py-1.5 px-3">
                    <div className="w-6 h-6 rounded-full bg-[#279EFF] border-[3px] border-[#51B1FF] text-xs font-bold flex justify-center items-center">
                      S
                    </div>
                    {formatAmount(buyPrice, 18, 4)} ETH
                  </div>

                  <div className="text-xs text-center font-normal text-[#40F8FF]">
                    You own {accountShares ?? 0} Share
                  </div>
                </div>
                <div className="flex justify-center items-center gap-6 px-12">
                  <div className="flex flex-col text-center gap-1">
                    <span>
                      {tiktokUserInfo?.follower_count
                        ? formatNumber(tiktokUserInfo?.follower_count)
                        : "-"}
                    </span>{" "}
                    <span className="text-xs text-slate-500">Follower</span>
                  </div>
                  <div className="flex flex-col text-center gap-1">
                    <span>{tiktokUserInfo?.total_shares || "-"}</span>{" "}
                    <span className="text-xs text-slate-500">Shares</span>
                  </div>
                  <div
                    className="flex flex-col text-center gap-1"
                    onClick={() => {
                      navigate(
                        `/profile/activities/${data?.tiktok_user_id}?tab=Holders`,
                        {
                          state: {
                            nickname: data?.tiktok_user_info?.nickname,
                            avatar: avatarSmall,
                            id: data?.id,
                            tiktok_user_id: data?.tiktok_user_id,
                          },
                        }
                      );
                    }}
                  >
                    <span>{tiktokUserInfo?.total_holders || "-"}</span>{" "}
                    <span className="text-xs text-slate-500">Holders</span>
                  </div>
                  <div
                    className="flex flex-col text-center gap-1"
                    onClick={() => {
                      navigate(
                        `/profile/activities/${data?.tiktok_user_id}?tab=Holdings`,
                        {
                          state: {
                            nickname: data?.tiktok_user_info?.nickname,
                            avatar: avatarSmall,
                            id: data?.id,
                            tiktok_user_id: data?.tiktok_user_id,
                          },
                        }
                      );
                    }}
                  >
                    <span>{tiktokUserInfo?.total_holdings || "-"}</span>{" "}
                    <span className="text-xs text-slate-500">Holdings</span>
                  </div>
                </div>
              </div>

              <div className="flex gap-2 items-center justify-center">
                {!!poolSupply && !accountShares && (
                  <button
                    className="rounded-xl btn bg-secondary uppercase"
                    onClick={(e) => {
                      e.preventDefault();
                      handleBuyShare();
                    }}
                  >
                    Buy a share
                  </button>
                )}
                {!!poolSupply && !!accountShares && (
                  <button
                    className="rounded-xl btn bg-[#1BC57E] uppercase"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleModalTrade();
                    }}
                  >
                    Trade a share
                  </button>
                )}
                {!poolSupply && (
                  <button
                    className="rounded-xl btn bg-[#279EFF] uppercase"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(slugs.buyFirstShare, { replace: true });
                    }}
                  >
                    Activate share
                  </button>
                )}

                <button
                  className="border-2 border-gray-800 rounded-xl btn btn-outline uppercase"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`${slugs.profile}/activities/${data?.id}`, {
                      state: {
                        nickname: data?.tiktok_user_info?.nickname,
                        avatar: avatarSmall,
                        id: data?.id,
                        tiktok_user_id: data?.tiktok_user_id,
                      },
                    });
                  }}
                >
                  Activities{" "}
                </button>
              </div>

              <span className="text-slate-300 text-sm text-center">
                {tiktokUserInfo?.metadata?.signature
                  ? tiktokUserInfo?.metadata.signature
                  : null}
              </span>
            </div>
          </div>
          <div className="px-4 flex justify-evenly items-center gap-6 border-b border-gray-800 text-center z-10">
            {tabs.map((tab) => (
              <div
                key={tab.name}
                className={classNames(
                  tab.name === currentTab
                    ? "border-secondary text-white"
                    : "border-transparent text-slate-300 hover:border-secondary hover:text-white",
                  "whitespace-nowrap border-b-4 rounded text-sm font-normal py-2 w-full px-1 cursor-pointer"
                )}
                onClick={() => {
                  setCurrentTab(tab.name);
                }}
              >
                {tab.name}
              </div>
            ))}
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            {tabRender()}
          </div>
        </>
      )}
    </>
  );
}

export { Profile as default };
